import { render, staticRenderFns } from "./VideoHome.vue?vue&type=template&id=43e6ed55"
import script from "./VideoHome.vue?vue&type=script&lang=js"
export * from "./VideoHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports